import { Text } from "@certn/cascadia";
import { DataDisplay } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import type { EnrollmentDetailCheck } from "../types";
import { monitoringDetailsTableWrapperStyle } from "./monitoringDetailsTableStyles";

type AlertRow = EnrollmentDetailCheck["alert_notifications"][number] & {
  id: string;
};

const COLUMN_WIDTH = "33%";

export function MonitoringAlertNotificationsTable({
  alerts,
}: {
  alerts: EnrollmentDetailCheck["alert_notifications"];
}) {
  const { t } = useTranslation();

  const rows: AlertRow[] = alerts.map((alert, index) => ({
    ...alert,
    id: `${alert.attribute}-${index}`,
  }));

  return (
    <div className={monitoringDetailsTableWrapperStyle}>
      <DataDisplay<AlertRow>
        testId="monitoring-alert-notifications-table"
        renderTopMargin={false}
        hideHeaderBorder
        aria-label={t("Alert notifications")}
        columns={[
          {
            key: "attribute",
            name: t("Attribute"),
            width: COLUMN_WIDTH,
            isRowHeader: true,
            render: (row) => (
              <Text style="form/body-secondary">{row.attribute}</Text>
            ),
          },
          {
            key: "value",
            name: t("Value"),
            width: COLUMN_WIDTH,
            render: (row) => (
              <Text style="form/body-secondary">{row.value || "-"}</Text>
            ),
          },
          {
            key: "information",
            name: t("Information"),
            width: COLUMN_WIDTH,
            render: (row) => (
              <Text style="form/body-secondary">{row.information}</Text>
            ),
          },
        ]}
        rows={rows}
      />
    </div>
  );
}
